module.exports = __webpack_public_path__ + "img/select.01569f2c.png";